import { render } from "./environment-card.vue?vue&type=template&id=4803bd43&scoped=true"
import script from "./environment-card.vue?vue&type=script&lang=ts"
export * from "./environment-card.vue?vue&type=script&lang=ts"

import "./environment-card.vue?vue&type=style&index=0&id=4803bd43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4803bd43"

export default script